export const EngIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="8" fill="#C4C4C4" />
        <circle cx="10" cy="10" r="8.8" stroke="white" strokeOpacity="0.8" strokeWidth="1" />
        <path
            d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
            fill="white"
        />
        <path
            d="M3.65355 5.1297C3.02514 5.94729 2.5513 6.88964 2.27539 7.91336H6.4372L3.65355 5.1297Z"
            fill="#0263E0"
        />
        <path
            d="M17.7243 7.91314C17.4483 6.88945 16.9745 5.94711 16.3461 5.12952L13.5625 7.91314H17.7243Z"
            fill="#0263E0"
        />
        <path
            d="M2.27539 12.087C2.55133 13.1107 3.02517 14.0531 3.65355 14.8706L6.43711 12.087H2.27539Z"
            fill="#0263E0"
        />
        <path
            d="M14.8701 3.65391C14.0525 3.02551 13.1101 2.55166 12.0864 2.27573V6.43751L14.8701 3.65391Z"
            fill="#0263E0"
        />
        <path
            d="M5.12891 16.3464C5.9465 16.9748 6.88884 17.4486 7.91253 17.7246V13.5628L5.12891 16.3464Z"
            fill="#0263E0"
        />
        <path
            d="M7.9125 2.2757C6.88881 2.55163 5.94647 3.02548 5.12891 3.65385L7.9125 6.43745V2.2757Z"
            fill="#0263E0"
        />
        <path
            d="M12.0864 17.7246C13.1101 17.4486 14.0525 16.9748 14.87 16.3464L12.0864 13.5628V17.7246Z"
            fill="#0263E0"
        />
        <path
            d="M13.5625 12.087L16.3461 14.8707C16.9745 14.0531 17.4483 13.1107 17.7243 12.087H13.5625Z"
            fill="#0263E0"
        />
        <path
            d="M17.9323 8.95653H11.0435H11.0435V2.06772C10.7019 2.02325 10.3537 2 10 2C9.64628 2 9.29809 2.02325 8.95653 2.06772V8.95647V8.9565H2.06772C2.02325 9.29809 2 9.64634 2 10C2 10.3537 2.02325 10.7019 2.06772 11.0435H8.95647H8.9565V17.9323C9.29809 17.9768 9.64628 18 10 18C10.3537 18 10.7019 17.9768 11.0435 17.9323V11.0435V11.0435H17.9323C17.9768 10.7019 18 10.3537 18 10C18 9.64634 17.9768 9.29809 17.9323 8.95653Z"
            fill="#F22F46"
        />
        <path
            d="M12.0874 12.0869L15.6573 15.6568C15.8215 15.4927 15.9781 15.3211 16.1275 15.1432L13.0712 12.0869H12.0874V12.0869Z"
            fill="#F22F46"
        />
        <path
            d="M7.91317 12.0869H7.9131L4.34326 15.6568C4.50739 15.8209 4.67898 15.9776 4.85686 16.127L7.91317 13.0706V12.0869Z"
            fill="#F22F46"
        />
        <path
            d="M7.91268 7.91311V7.91305L4.34281 4.34314C4.17862 4.50726 4.022 4.67886 3.87256 4.85673L6.9289 7.91308H7.91268V7.91311Z"
            fill="#F22F46"
        />
        <path
            d="M12.0874 7.9132L15.6573 4.34327C15.4932 4.17908 15.3216 4.02245 15.1437 3.87305L12.0874 6.92939V7.9132Z"
            fill="#F22F46"
        />
    </svg>
);
